import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

//для css анимации
// import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import { TransitionGroup, CSSTransition } from 'react-transition-group';

//для анимации высоты
import { Collapse } from 'react-collapse';

import s from './Animation.scss';
import cls from 'classnames/bind';

//default ANIMATION_TYPES.OPACITY
export const ANIMATION_TYPES = {
  OPACITY: 'opacity',
  DELAYED_OPACITY: 'delayed-opacity',
  HEIGHT: 'height',
  BOUNCE: 'bounce',
  FLOAT: 'float',
  FLOAT_UP: 'float-up',
  FAST_FLOAT_UP: 'fast-float-up',
  TOGGLE_OPACITY: 'toggle-opacity',
};

export const DEFAULT_ANIMATION_DURATION = 300;

export const ANIMATION_DELAYS = {
  [ANIMATION_TYPES.OPACITY]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION,
  },
  [ANIMATION_TYPES.DELAYED_OPACITY]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION + 100,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION + 100,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION + 100,
  },
  [ANIMATION_TYPES.BOUNCE]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION,
  },
  [ANIMATION_TYPES.FLOAT]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION / 2,
  },
  [ANIMATION_TYPES.FLOAT_UP]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION / 2,
  },
  [ANIMATION_TYPES.FAST_FLOAT_UP]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION / 2,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION / 2,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION / 4,
  },
  [ANIMATION_TYPES.TOGGLE_OPACITY]: {
    transitionAppearTimeout: DEFAULT_ANIMATION_DURATION / 2,
    transitionEnterTimeout: DEFAULT_ANIMATION_DURATION / 2,
    transitionLeaveTimeout: DEFAULT_ANIMATION_DURATION / 2,
  },
};

const cx = cls.bind(s);

class Animation extends PureComponent {
  static propTypes = {
    type: PropTypes.oneOf(Object.values(ANIMATION_TYPES)),

    // на каких стадиях будет включена анимация
    appear: PropTypes.bool,
    enter: PropTypes.bool,
    leave: PropTypes.bool,

    // будет ли показываться блок
    show: PropTypes.bool,
  };
  static defaultProps = {
    type: ANIMATION_TYPES.OPACITY,

    appear: false,
    enter: true,
    leave: true,

    show: true,
  };

  constructor(props, ctx) {
    super(props, ctx);
  }

  getCollapseProps = () => {
    return {
      isOpened: this.props.show,
      forceInitialAnimation: this.props.appear,
    };
  };

  getTransitionTimeouts = () => {
    const propsTimeouts = Object.keys({
      transitionAppearTimeout: this.props.appearTimeout,
      transitionEnterTimeout: this.props.enterTimeout,
      transitionLeaveTimeout: this.props.leaveTimeout,
    }).reduce((timeouts, key, index, props) => {
      if (props[key] !== undefined) timeouts[key] = props[key];
      return timeouts;
    }, {});

    return {
      ...ANIMATION_DELAYS[this.props.type],
      ...propsTimeouts,
    };
  };

  getTransitionGroupsProps = forcedType => {
    const type = forcedType || this.props.type;

    return {
      ...this.getTransitionTimeouts(),
      transitionAppear: this.props.appear,
      transitionEnter: this.props.enter,
      transitionLeave: this.props.leave,
      transitionName: {
        enter: cx(`animation-${type}-enter`),
        leave: cx(`animation-${type}-leave`),
        appear: cx(`animation-${type}-appear`),
      },
    };
  };

  render() {
    switch (this.props.type) {
      case ANIMATION_TYPES.HEIGHT:
        return <Collapse {...this.getCollapseProps()}>{this.props.children}</Collapse>;
      case ANIMATION_TYPES.OPACITY:
      case ANIMATION_TYPES.BOUNCE:
      case ANIMATION_TYPES.FLOAT:
      case ANIMATION_TYPES.FLOAT_UP:
      case ANIMATION_TYPES.FAST_FLOAT_UP:
      case ANIMATION_TYPES.TOGGLE_OPACITY:
      default:
        return (
          <TransitionGroup>
            <CSSTransition timeout={500} {...this.getTransitionGroupsProps()}>
              {this.props.children}
            </CSSTransition>
          </TransitionGroup>
        );
    }
  }
}

export default Animation;
